import axios from 'axios'
import utils from '@/libs/utils'

let instance = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT, //process.env.API_ROOT,
  timeout: 60 * 1000,
  // withCredentials: true
  responseType: 'json'
})

instance.interceptors.request.use(config => {
  if (localStorage) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem("h5Token")
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  if (response.status >= 200 && response.status < 300) {
    if (response.config.responseType != 'json') {
      return response
    } else {
      if (response.data) localStorage.setItem("h5Token", response.data.token)
      return response.data
    }
  } else {
    return { status: response.status, msg: 'err' }
  }
}, error => {
  //token过期 重新登陆
  if (error.response.status == 401) {
    window.localStorage.clear()
    setTimeout(function () {
      window.location.href = '/login'
    }, 500)
  } else if (error.response.status == 403) {
    window.localStorage.clear()
    setTimeout(function () {
      window.location.href = '/login?kickout=1'
    }, 500)
  }
  return Promise.reject(error)
})

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$axiosH5', { value: instance })
  }
}